import { Button, ConfirmationButton, StandardDialog } from "@roc/ui";
import { observer } from "mobx-react";
import { PayoffRequestDetails } from "./payoffRequestDetails";
import { useDocumentStore } from "@roc/feature-documents";
import { Grid } from "@material-ui/core";
import { useEffect } from "react";
import { usePayoffRequestStore } from "@roc/feature-loans";
import { CustomTaskDialog } from "@roc/feature-general-tasks";
import { Document } from "@roc/feature-types";
import { format } from "date-fns";

export type PayoffRequestDetailDialogProps = {
  open: boolean;
  loanId: any;
  onClose: () => void;
  isEditMode: boolean;
  document: Document;
};

export const PayoffRequestDetailDialog = observer((props: PayoffRequestDetailDialogProps) => {
  const { open, loanId, onClose, isEditMode, document } = props;
  const { payoffRequestStore } = usePayoffRequestStore();
  const taskId = document?.taskId;
  const {
    documentStore: {
      documentFormStore: { payoffRequestDetailStore },
    },
  } = useDocumentStore();

  useEffect(() => {
    if (open) {
      payoffRequestDetailStore.reset();
      payoffRequestDetailStore.setLoanId(loanId);
      if (isEditMode) {
        payoffRequestDetailStore.getPayoffData(loanId, payoffRequestStore.selectedPayoffId);
      } else {
        payoffRequestDetailStore.onFieldChange("requestedDate", format(new Date(), 'MM/dd/yyyy'))
      }

    }
  }, [open]);

  const onSubmit = async () => {
    await payoffRequestDetailStore.submitPayoffRequestDetails(isEditMode, payoffRequestStore.selectedPayoffId);
    if (isEditMode) {
      await payoffRequestStore.getPayoffById(loanId, payoffRequestStore.selectedPayoffId);
    } else {
      await payoffRequestStore.getPayoffData(loanId);
    }
    if (payoffRequestDetailStore.form.meta.isValid)
      onClose();
  };

  const getActions = () => {
    return (
      <Grid container spacing={1} justifyContent="flex-end">
        <Grid item>
          <Button
            onClick={onClose}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <ConfirmationButton
            onClick={onSubmit}
            color="primary"
            variant="contained"
            testId="confirm"
            disabled={false}
            confirmDialogProps={{
              title: 'Request Payoff',
              body:
                'Are you sure you want to request payoff?',
            }}
          >
            Save
          </ConfirmationButton>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Payoff Request Details"
          handleClose={onClose}
          dialogContent={<PayoffRequestDetails store={payoffRequestDetailStore} isEditMode={isEditMode} />}
          dialogActions={getActions()}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Payoff Request Details"
          maxWidth="md"
          handleClose={onClose}
          dialogContent={<PayoffRequestDetails store={payoffRequestDetailStore} isEditMode={isEditMode} />}
          dialogActions={getActions()}
        />
      )}
    </>
  );
});

export default PayoffRequestDetailDialog;